import { Box } from '@mui/material';

import { useSearchPersist } from '@/components/DataGrid/hooks/useSearchPersist';
import { MasterNameView } from '@/layouts/TabLayout/MasterNames/components/MasterNameView';

import MasterIndexPersonBase from './MasterIndexPersonBase';

const MasterIndexPersonView = () => {
  const { navigateWithSearch } = useSearchPersist();

  return (
    <MasterIndexPersonBase>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          overflow: 'hidden',
        }}
      >
        <MasterNameView
          onGoBack={() => navigateWithSearch('/master-index/persons')}
          hideHeader={true}
          isMasterIndex={true}
        />
      </Box>
    </MasterIndexPersonBase>
  );
};

export default MasterIndexPersonView;
